import {TrackStyle} from './TrackStyle';
import {TrackStylesService} from '../track-styles.service';
import {SettingsService} from '../settings.service';

export class TrackStyles {

  static fallbackTrackStyle = new TrackStyle('', '#ffffff', 1.0, 0, 3, 0, null);

  roadStatusCoverageLevel1: TrackStyle = TrackStyles.fallbackTrackStyle;
  roadStatusCoverageLevel2: TrackStyle = TrackStyles.fallbackTrackStyle;
  roadStatusCoverageLevel3: TrackStyle = TrackStyles.fallbackTrackStyle;
  roadStatusCoverageLevel4: TrackStyle = TrackStyles.fallbackTrackStyle;
  roadStatusCoverageLevel5: TrackStyle = TrackStyles.fallbackTrackStyle;
  roadStatusCurrencyLevel1: TrackStyle = TrackStyles.fallbackTrackStyle;
  roadStatusCurrencyLevel2: TrackStyle = TrackStyles.fallbackTrackStyle;
  roadStatusCurrencyLevel3: TrackStyle = TrackStyles.fallbackTrackStyle;
  roadStatusCurrencyLevel4: TrackStyle = TrackStyles.fallbackTrackStyle;
  roadStatusCurrencyLevel5: TrackStyle = TrackStyles.fallbackTrackStyle;
  liveMapPlowLive: TrackStyle = TrackStyles.fallbackTrackStyle;
  liveMapPlowHighlighted: TrackStyle = TrackStyles.fallbackTrackStyle;
  liveMapPlowInactive: TrackStyle = TrackStyles.fallbackTrackStyle;
  shiftPlowNormal: TrackStyle = TrackStyles.fallbackTrackStyle;
  shiftPlowPlowDown: TrackStyle = TrackStyles.fallbackTrackStyle;
  shiftPlowSpreaderOn: TrackStyle = TrackStyles.fallbackTrackStyle;
  assignmentStatusServiced: TrackStyle = TrackStyles.fallbackTrackStyle;
  assignmentStatusInProgress: TrackStyle = TrackStyles.fallbackTrackStyle;
  assignmentStatusNotServiced: TrackStyle = TrackStyles.fallbackTrackStyle;
  routeStatusNotDone: TrackStyle = TrackStyles.fallbackTrackStyle;
  routeStatusLevel1: TrackStyle = TrackStyles.fallbackTrackStyle;
  routeStatusLevel2: TrackStyle = TrackStyles.fallbackTrackStyle;
  routeStatusLevel3: TrackStyle = TrackStyles.fallbackTrackStyle;

  static saveCurrency(trackStyles: TrackStyles, service: TrackStylesService): Promise<TrackStyles> {
    return service.saveTrackStyles([
      trackStyles.roadStatusCurrencyLevel1,
      trackStyles.roadStatusCurrencyLevel2,
      trackStyles.roadStatusCurrencyLevel3,
      trackStyles.roadStatusCurrencyLevel4,
      trackStyles.roadStatusCurrencyLevel5,
    ]);
  }

  static saveCoverage(trackStyles: TrackStyles, service: TrackStylesService): Promise<TrackStyles> {
    return service.saveTrackStyles([
      trackStyles.roadStatusCoverageLevel1,
      trackStyles.roadStatusCoverageLevel2,
      trackStyles.roadStatusCoverageLevel3,
      trackStyles.roadStatusCoverageLevel4,
      trackStyles.roadStatusCoverageLevel5,
    ]);
  }

  static saveGpsTracks(trackStyles: TrackStyles, service: TrackStylesService): Promise<TrackStyles> {
    return service.saveTrackStyles([
      trackStyles.liveMapPlowLive,
      trackStyles.liveMapPlowInactive,
    ]);
  }

  static saveAssignmentStatus(trackStyles: TrackStyles, service: TrackStylesService): Promise<TrackStyles> {
    return service.saveTrackStyles([
      trackStyles.assignmentStatusServiced,
      trackStyles.assignmentStatusInProgress,
      trackStyles.assignmentStatusNotServiced,
    ]);
  }

  static saveRouteStatus(trackStyles: TrackStyles, service: TrackStylesService): Promise<TrackStyles> {
    return service.saveTrackStyles([
      trackStyles.routeStatusNotDone,
      trackStyles.routeStatusLevel1,
      trackStyles.routeStatusLevel2,
      trackStyles.routeStatusLevel3,
    ]);
  }

  static resetCurrency(trackStyles: TrackStyles, service: TrackStylesService): Promise<TrackStyles> {
    return service.resetTrackStyles([
      trackStyles.roadStatusCurrencyLevel1,
      trackStyles.roadStatusCurrencyLevel2,
      trackStyles.roadStatusCurrencyLevel3,
      trackStyles.roadStatusCurrencyLevel4,
      trackStyles.roadStatusCurrencyLevel5,
    ]);
  }

  static resetCoverage(trackStyles: TrackStyles, service: TrackStylesService): Promise<TrackStyles> {
    return service.resetTrackStyles([
      trackStyles.roadStatusCoverageLevel1,
      trackStyles.roadStatusCoverageLevel2,
      trackStyles.roadStatusCoverageLevel3,
      trackStyles.roadStatusCoverageLevel4,
      trackStyles.roadStatusCoverageLevel5,
    ]);
  }

  static resetGpsTracks(trackStyles: TrackStyles, service: TrackStylesService): Promise<TrackStyles> {
    return service.resetTrackStyles([
      trackStyles.liveMapPlowLive,
      trackStyles.liveMapPlowInactive,
    ]);
  }

  static resetAssignmentStatus(trackStyles: TrackStyles, service: TrackStylesService): Promise<TrackStyles> {
    return service.resetTrackStyles([
      trackStyles.assignmentStatusServiced,
      trackStyles.assignmentStatusInProgress,
      trackStyles.assignmentStatusNotServiced,
    ]);
  }

  static resetRouteStatus(trackStyles: TrackStyles, service: TrackStylesService): Promise<TrackStyles> {
    return service.resetTrackStyles([
      trackStyles.routeStatusNotDone,
      trackStyles.routeStatusLevel1,
      trackStyles.routeStatusLevel2,
      trackStyles.routeStatusLevel3,
    ]);
  }

  static copy(it: TrackStyles): TrackStyles {
    const copy = new TrackStyles();
    copy.roadStatusCoverageLevel1 = Object.assign({}, it.roadStatusCoverageLevel1);
    copy.roadStatusCoverageLevel2 = Object.assign({}, it.roadStatusCoverageLevel2);
    copy.roadStatusCoverageLevel3 = Object.assign({}, it.roadStatusCoverageLevel3);
    copy.roadStatusCoverageLevel4 = Object.assign({}, it.roadStatusCoverageLevel4);
    copy.roadStatusCoverageLevel5 = Object.assign({}, it.roadStatusCoverageLevel5);
    copy.roadStatusCurrencyLevel1 = Object.assign({}, it.roadStatusCurrencyLevel1);
    copy.roadStatusCurrencyLevel2 = Object.assign({}, it.roadStatusCurrencyLevel2);
    copy.roadStatusCurrencyLevel3 = Object.assign({}, it.roadStatusCurrencyLevel3);
    copy.roadStatusCurrencyLevel4 = Object.assign({}, it.roadStatusCurrencyLevel4);
    copy.roadStatusCurrencyLevel5 = Object.assign({}, it.roadStatusCurrencyLevel5);
    copy.liveMapPlowLive = Object.assign({}, it.liveMapPlowLive);
    copy.liveMapPlowHighlighted = Object.assign({}, it.liveMapPlowHighlighted);
    copy.liveMapPlowInactive = Object.assign({}, it.liveMapPlowInactive);
    copy.shiftPlowNormal = Object.assign({}, it.shiftPlowNormal);
    copy.shiftPlowPlowDown = Object.assign({}, it.shiftPlowPlowDown);
    copy.shiftPlowSpreaderOn = Object.assign({}, it.shiftPlowSpreaderOn);
    copy.assignmentStatusServiced = Object.assign({}, it.assignmentStatusServiced);
    copy.assignmentStatusInProgress = Object.assign({}, it.assignmentStatusInProgress);
    copy.assignmentStatusNotServiced = Object.assign({}, it.assignmentStatusNotServiced);
    copy.routeStatusNotDone = Object.assign({}, it.routeStatusNotDone);
    copy.routeStatusLevel1 = Object.assign({}, it.routeStatusLevel1);
    copy.routeStatusLevel2 = Object.assign({}, it.routeStatusLevel2);
    copy.routeStatusLevel3 = Object.assign({}, it.routeStatusLevel3);
    return copy;
  }

  static enhanceFromSettings(trackStyles: TrackStyles, service: SettingsService) {
    const userTrackStyles = TrackStyles.copy(trackStyles);

    TrackStyles.updateStyleFromSettings(userTrackStyles, 'roadStatusCoverageLevel1', SettingsService.COVERAGE_TRACK_STYLE_1, service);
    TrackStyles.updateStyleFromSettings(userTrackStyles, 'roadStatusCoverageLevel2', SettingsService.COVERAGE_TRACK_STYLE_2, service);
    TrackStyles.updateStyleFromSettings(userTrackStyles, 'roadStatusCoverageLevel3', SettingsService.COVERAGE_TRACK_STYLE_3, service);
    TrackStyles.updateStyleFromSettings(userTrackStyles, 'roadStatusCoverageLevel4', SettingsService.COVERAGE_TRACK_STYLE_4, service);
    TrackStyles.updateStyleFromSettings(userTrackStyles, 'roadStatusCoverageLevel5', SettingsService.COVERAGE_TRACK_STYLE_5, service);

    TrackStyles.updateStyleFromSettings(userTrackStyles, 'roadStatusCurrencyLevel1', SettingsService.CURRENCY_TRACK_STYLE_1, service);
    TrackStyles.updateStyleFromSettings(userTrackStyles, 'roadStatusCurrencyLevel2', SettingsService.CURRENCY_TRACK_STYLE_2, service);
    TrackStyles.updateStyleFromSettings(userTrackStyles, 'roadStatusCurrencyLevel3', SettingsService.CURRENCY_TRACK_STYLE_3, service);
    TrackStyles.updateStyleFromSettings(userTrackStyles, 'roadStatusCurrencyLevel4', SettingsService.CURRENCY_TRACK_STYLE_4, service);
    TrackStyles.updateStyleFromSettings(userTrackStyles, 'roadStatusCurrencyLevel5', SettingsService.CURRENCY_TRACK_STYLE_5, service);

    TrackStyles.updateStyleFromSettings(userTrackStyles, 'liveMapPlowLive', SettingsService.GPS_TRACK_ACTIVE_TRACK_STYLE, service);
    TrackStyles.updateStyleFromSettings(userTrackStyles, 'liveMapPlowInactive', SettingsService.GPS_TRACK_RECENT_TRACK_STYLE, service);

    TrackStyles.updateStyleFromSettings(userTrackStyles, 'assignmentStatusServiced', SettingsService.ASSIGNMENT_STATUS_SERVICED_STYLE, service);
    TrackStyles.updateStyleFromSettings(userTrackStyles, 'assignmentStatusInProgress', SettingsService.ASSIGNMENT_STATUS_IN_PROGRESS_STYLE, service);
    TrackStyles.updateStyleFromSettings(
      userTrackStyles,
      'assignmentStatusNotServiced',
      SettingsService.ASSIGNMENT_STATUS_NOT_SERVICED_STYLE,
      service,
    );

    TrackStyles.updateStyleFromSettings(userTrackStyles, 'routeStatusNotDone', SettingsService.ROUTE_STATUS_STYLE_NOT_DONE, service);
    TrackStyles.updateStyleFromSettings(userTrackStyles, 'routeStatusLevel1', SettingsService.ROUTE_STATUS_STYLE_1, service);
    TrackStyles.updateStyleFromSettings(userTrackStyles, 'routeStatusLevel2', SettingsService.ROUTE_STATUS_STYLE_2, service);
    TrackStyles.updateStyleFromSettings(userTrackStyles, 'routeStatusLevel3', SettingsService.ROUTE_STATUS_STYLE_3, service);

    return userTrackStyles;
  }

  private static updateStyleFromSettings(trackStyles: TrackStyles, field: string, settingsName: string, settingsService: SettingsService) {
    const styleSettings = settingsService.getStringValue(settingsName);
    if (!!styleSettings && styleSettings !== 'null') {
      trackStyles[field] = JSON.parse(styleSettings) as TrackStyle;
      try {
      } catch (e) {
        console.warn(`${settingsName} setting cannot be parsed as JSON.`);
      }
    } else {
      // console.debug('CoverageLevel1TrackStyle setting is null');
    }
  }
}
